import type { ReactNode, TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export function OpPrimaryField({
  label = "Główne pole",
  hint,
  className,
  textareaClassName,
  ...props
}: {
  label?: string;
  hint?: ReactNode;
  textareaClassName?: string;
} & TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <div className={cn("space-y-2", className)}>
      <div>
        <label className="text-sm font-semibold text-slate-900">{label}</label>
        {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
      </div>
      <textarea
        className={cn(
          "min-h-[180px] w-full rounded-lg border-2 border-brand bg-white p-3 text-base text-slate-900 shadow-sm",
          "placeholder:text-slate-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2",
          "disabled:cursor-not-allowed disabled:opacity-50",
          textareaClassName,
        )}
        {...props}
      />
    </div>
  );
}
